import { cn } from '@shared/cove-ui';
import { Minus } from '../../Icons';

const CollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div className="p-cove-10 relative flex cursor-pointer items-center justify-center border-0 bg-transparent">
      <Minus className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-all" />
      <Minus
        className={cn(
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-all',
          !expanded && 'rotate-90'
        )}
      />
      <span className="sr-only">
        {expanded ? 'Collapse' : 'Expand'} section
      </span>
    </div>
  );
};

export default CollapseIcon;
